exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!./node_modules/style-loader!./node_modules/css-loader??ref--9-2!./node_modules/postcss-loader/lib??ref--9-3!./node_modules/sass-loader/dist/cjs.js??ref--9-4!./src/assets/styles/home.scss
// module id = gBeF
// module chunks = 0